const translations = {
  en: {
    title: 'Contact',
    subtitle: 'Get in touch',
    rights: 'All rights reserved.',
    githubLine: 'github.com/',
  },
  pt: {
    title: 'Contato',
    subtitle: 'Entre em contato',
    rights: 'Todos os direitos reservados.',
    githubLine: 'github.com/',
  },
};

export default translations;
